import { getLocationPrimaryResident } from '../locationUser/primaryResident'
import {
  chooseLatestActivity,
  findLatestTag,
  type AccountData,
  type ContactData,
  type ExtendedLocationData,
  type TinyAccountContact,
  type TinyLocationData,
} from '@terros/common'

export function toTinyLocation(newLoc: ExtendedLocationData): TinyLocationData {
  const accountContact = toAccountContact(newLoc)
  return {
    ...newLoc.latlng,
    locationId: newLoc.locationId,
    address: newLoc.line1,
    city: newLoc.locality,
    state: newLoc.countrySubd,
    zip: newLoc.postal1,
    accountContact,
    resident: getLocationPrimaryResident(newLoc),
    notes: newLoc.notes,
  }
}

function toAccountContact(newLoc: ExtendedLocationData): TinyAccountContact {
  const { locationId, contacts, account } = newLoc
  const accountDate = getAccountUpdateDate(account)
  const contactDate = getContactUpdateDate(contacts)

  if (accountDate && contactDate) {
    if (contactDate > accountDate) {
      return {
        locationId,
        user: 'self',
        disposition: newLoc.disposition,
      }
    } else {
      return {
        locationId,
        user: 'self',
        statusId: newLoc.account?.statusId,
      }
    }
  }
  const workflowActionOrTagId = chooseLatestActivity(findLatestTag(newLoc.account?.tags), {
    actionId: newLoc.account?.workflowActionId,
    timestamp: accountDate,
  })

  if (accountDate) {
    return {
      locationId,
      user: 'self',
      statusId: newLoc.account?.statusId,
      workflowStageId: newLoc.account?.workflowStageId,
      workflowActionOrTagId,
    }
  }
  if (contactDate) {
    return {
      locationId,
      user: 'self',
      disposition: newLoc.disposition,
    }
  }

  return {
    locationId,
    user: 'self',
    statusId: newLoc.account?.statusId,
    disposition: newLoc.disposition,
    workflowStageId: newLoc.account?.workflowStageId,
    workflowActionOrTagId,
  }
}

const getContactUpdateDate = (contacts: ContactData[] | undefined): number | undefined => {
  if (!contacts) return

  const date = contacts.reduce((acc, hi) => {
    if (hi.contactDate > acc) return hi.contactDate
    return acc
  }, -1)

  if (date === -1) return

  return date
}

const getAccountUpdateDate = (account: AccountData | undefined): number | undefined => {
  if (!account) return

  const date = account.statusHistory.reduce((acc, hi) => {
    if (hi.statusChangedDate > acc) return hi.statusChangedDate
    return acc
  }, -1)

  if (date === -1) return account.updatedAt

  return date
}
